module.exports = __webpack_public_path__ + "img/history_image.png";